// extracted by mini-css-extract-plugin
export default {"settings":"_mDTR6TZf9XzLKTqV50f"};